export const PARTNER_TYPE = {
  "exhibition company": "Exhibitors",
  "b2b publisher": "Advertisers",
  "growth hub": "Members",
  "innovation centre": "Members",
  "trade body": "Members",
  "chamber of commerce": "Members",
};